export default function Articles() {
    return {
        restrict: "E",
        scope: {
            articles: "=",
        },
        template: require("./template.html"),
        // controller: function($scope, $rootScope) {}
    };
}
